export default function useWebViewDetector() {
    const isWebView = () => {
        const userAgent = navigator.userAgent;

        // Android WebView
        if (userAgent.includes('wv') && userAgent.includes('Android')) {
            return true;
        }

        // iOS WebView (UIWebView/WKWebView)
        if (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent)) {
            return true;
        }

        // Другие признаки WebView
        return (userAgent.includes('WebView') ||
            userAgent.includes('AppWebView') ||
            userAgent.includes('Mobile/')) && !userAgent.includes('Safari/');
    }

    return {isWebView}
}